import * as cert2json from 'Core/CertificateParser/certificate'
import { Buffer } from 'buffer'

const parsePem = (base64encodedCert) => {
  console.log('[clouds](decode):', base64encodedCert)
  const PEM = Buffer.from(base64encodedCert, 'base64').toString('utf-8')
  const certs = PEM.split('-----BEGIN CERTIFICATE-----').map(
    (cert) => '-----BEGIN CERTIFICATE-----' + cert
  )
  console.log('[certs](certs):', certs)
  certs.shift()
  const decoded = certs.map((cert) => ({ decoded: cert2json.parsePem(cert), cert }))
  if (decoded) return decoded
}

const parsePem64 = (base64encodedCert) => {
  const decoded = cert2json.parsePem(base64encodedCert)
  if (decoded) return decoded
}

export { parsePem, parsePem64 }
